/**
 * @file 访问前缀（/fp、/lawyer）探测与站内路径拼接
 * @desc 应用支持通过 /fp/account/index 与 /lawyer/account/index 两套前缀访问，
 *       此模块在运行时根据当前 URL 探测前缀，供路由 base 与站内跳转统一使用。
 *       注意：本模块须保持零 import，避免与 router/util 形成循环依赖。
 */

// 访问路径固定后缀
const ACCESS_SUFFIX = '/account/index';
// 受支持的前缀，第一个为兜底默认
const SUPPORTED_PREFIXES = ['fp', 'lawyer'];

// 探测当前访问前缀，未命中时兜底为 fp
export function getAccessPrefix() {
    const pathname = (typeof window !== 'undefined'
        && window.location && window.location.pathname) || '';
    // 只要路径以 /{prefix} 开头即视为该前缀，
    // 兼容裸 /lawyer、/lawyer/ 以及 /lawyer/account/index/... 等形态
    const matched = SUPPORTED_PREFIXES.find(
        prefix => pathname === `/${prefix}` || pathname.startsWith(`/${prefix}/`)
    );
    return matched || SUPPORTED_PREFIXES[0];
}

// 当前访问对应的路由 base，如 /fp/account/index 或 /lawyer/account/index
export function getRouterBase() {
    return `/${getAccessPrefix()}${ACCESS_SUFFIX}`;
}

// 将站内相对路径拼成带当前前缀的绝对路径
// withBase('/lawinfo') => '/lawyer/account/index/lawinfo'（当前在 lawyer 前缀时）
export function withBase(path = '') {
    const normalized = path.startsWith('/') ? path : `/${path}`;
    return `${getRouterBase()}${normalized}`;
}

// 匹配任一受支持前缀的站内绝对路径，捕获组 1 为内部路由段
// 例：/lawyer/account/index/consult => 捕获 '/consult'
export const IN_APP_PATH_REGEX = new RegExp(
    `^/(?:${SUPPORTED_PREFIXES.join('|')})/account/index(/.*)`
);
